export default __webpack_public_path__ + "static/media/cnp20_7.b876e4cb.png";